<template>
  <div>
    <v-row>
      <v-col>
        <v-toolbar flat color="transparent">
          <v-toolbar-title>
            Resurseudgifter
          </v-toolbar-title>
        </v-toolbar>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        Hjemme
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        Træk og opsummer fra grupper og sektioner
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'SpecificationResources'
}
</script>
